// LOADING THE GOOGLE MAPS SCRIPT, ONCE.
//
// Two maps on one page is two callers asking for it, and the naive version of
// this - "is there already a script tag with this src?" - resolves the second
// one immediately while the first is still downloading, so the second map calls
// `new google.maps.Map` against an undefined global. Memoising the PROMISE is
// what makes the second caller wait for the first caller's load.
const loads = new Map()

export function loadGoogleMaps(url) {
  if (typeof google !== 'undefined' && google.maps) return Promise.resolve()

  if (!loads.has(url)) {
    loads.set(url, new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = url
      script.async = true
      script.defer = true
      script.onload = () => resolve()
      // Dropped from the cache on failure so that a map connecting later - after
      // a Turbo visit, say - gets a fresh attempt rather than the old rejection.
      script.onerror = () => { loads.delete(url); reject(new Error('Google Maps failed to load')) }
      document.head.appendChild(script)
    }))
  }

  return loads.get(url)
}

// THE BASEMAP, DRAINED. For a map whose whole job is comparing two coloured
// lines, Google's own palette is noise - a blue motorway and a green park are
// as loud as the route drawn over them. Everything geometric goes to grey and
// pale, labels stay readable, and the points of interest go entirely: nobody
// comparing a plan against a trail needs to know where the nearest cafe was.
//
// Opt-in per map, because a map of where the whole fleet is RIGHT NOW is read by
// glancing at it and the road colours are part of how that is read.
//
// HERE RATHER THAN IN ONE MAP, because two maps now draw those two lines: the
// schedule review's, through google_map_controller, and the live view's focused
// team, through LiveApp/RoundMap. A line has to mean the same thing on both
// screens, and so does the grey it is drawn on - two copies of this array is one
// of them being tuned and the other quietly diverging.
export const GREYSCALE_STYLES = [
  { elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 25 }] },
  { elementType: "labels.text.fill", stylers: [{ saturation: -100 }, { lightness: -25 }] },
  { elementType: "labels.text.stroke", stylers: [{ saturation: -100 }, { lightness: 60 }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 35 }] },
  { featureType: "water", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 45 }] },
  { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ saturation: -100 }] },
]
